
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120 20C64.865 20 20 64.865 20 120s44.865 100 100 100 100-44.865 100-100c-.056-55.135-44.865-100-100-100zm0 191.535c-50.508 0-91.535-41.084-91.535-91.535 0-50.451 41.084-91.535 91.535-91.535 50.508 0 91.535 41.084 91.535 91.535 0 50.451-41.084 91.535-91.535 91.535zm38.375-110.384h-.621V86.535c0-20.824-16.93-37.81-37.81-37.81-20.824 0-37.811 16.93-37.811 37.81v14.616h-.621c-7.505 0-13.6 6.095-13.6 13.601v52.144c0 7.506 6.095 13.601 13.6 13.601h76.806c7.506 0 13.601-6.095 13.601-13.601v-52.144c.056-7.506-6.039-13.601-13.544-13.601zm-67.72-14.672c0-16.197 13.149-29.346 29.345-29.346 16.196 0 29.345 13.149 29.345 29.346v14.616h-58.69V86.479zm72.912 80.417c0 2.822-2.314 5.136-5.136 5.136H81.569c-2.822 0-5.136-2.314-5.136-5.136v-52.144c0-2.822 2.314-5.136 5.136-5.136h76.806c2.821 0 5.135 2.314 5.135 5.136v52.144h.057zM120 116.219c-9.537 0-17.269 7.731-17.269 17.269 0 4.74 1.919 9.142 5.305 12.415v7.506c0 6.602 5.361 11.963 11.964 11.963 6.603 0 11.964-5.361 11.964-11.963v-7.506c3.386-3.217 5.305-7.675 5.305-12.415 0-9.481-7.788-17.269-17.269-17.269zm5.192 24.323a4.17 4.17 0 00-1.693 3.386v9.481a3.48 3.48 0 01-3.499 3.498 3.516 3.516 0 01-3.499-3.498v-9.481a4.17 4.17 0 00-1.693-3.386c-2.257-1.693-3.612-4.289-3.612-7.054 0-4.854 3.951-8.86 8.86-8.86 4.91 0 8.86 3.95 8.86 8.86-.112 2.821-1.41 5.361-3.724 7.054z","fill-rule":"nonzero"}})])
          )
        }
      }
    